import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash-es';

import ProgressBar from '../../../../../components/shared/ProgressBar/ProgressBar';

import styles from './CandidateProgressBar.module.scss';

const PROGRESS_VALUES = [
  'current_employer',
  'current_location',
  'current_title',
  'joining_date',
  'license_available',
  'candidate_skills',
  'diversity_hire',
  'links_json',
  'files',
];

const CandidateProgressBar = ({ organizationName = '' }) => {
  const { t } = useTranslation('common');
  const progressBarPercent = organizationName === 'Connect Pediatrics' ? Math.ceil(80 / 9) : 80 / 8;
  const { values } = useFormikContext();
  const progress = useMemo(() => {
    let progressPercentage = 20;
    PROGRESS_VALUES.forEach((value) => {
      if (value === 'joining_date' && !isEmpty(String(values.joining_date))) {
        progressPercentage += progressBarPercent;
      } else if (value === 'diversity_hire' && values[value]) {
        progressPercentage += progressBarPercent;
      } else if (value === 'files') {
        const newFiles = values.files.filter(({ _destroy }) => !_destroy);
        if (!isEmpty(newFiles)) {
          progressPercentage += progressBarPercent;
        }
      } else if (value === 'links_json') {
        const links = values.links_json.map((link) => link.value).join();
        if (!isEmpty(links)) {
          progressPercentage += progressBarPercent;
        }
      } else if (!isEmpty(values[value])) {
        progressPercentage += progressBarPercent;
      }
    });
    const totalProgress = Math.min(progressPercentage, 100);
    return totalProgress;
  }, [values]);

  return (
    <div className={styles.container}>
      <div className={styles.separator} />
      <div className={styles.bottomPadding}>
        <span className={styles.heading}>{t('strengthen.makeApplicationStandOut')}</span>
      </div>
      <ProgressBar percentage={progress} heading={t('application.applicationStrength')} />
    </div>
  );
};

export default CandidateProgressBar;
